{
  "sources": ["painting-1538", "woodcut-1544", "aar47-spuistraat"],
  "notes": "The painted outlines and 1544 woodcut show an enclosed garden compound and three internal divisions. The woodcut's vertical boundary marks guide the timber paling form; its exact material in 1538 is uncertain. All dimensions, joinery, inset, openings and their positions are modeling estimates. Garden vertices refer to the fitted layout, not traced medieval parcels. One shared fence divides each pair of gardens. Archaeological house walls replace fencing where they meet the boundary.",
  "height": 1.1,
  "postHeight": 1.2,
  "postHalf": 0.06,
  "postSpacing": 2.2,
  "boardWidth": 0.13,
  "boardThickness": 0.028,
  "boardSpacing": 0.17,
  "railHalf": 0.035,
  "railHeights": [0.32, 0.86],
  "inset": 0.1,
  "houseClearance": 0.25,
  "openingWidth": 1.6,
  "gardens": [
    { "id": "garden-raamsteeg-1", "front": [0, 1], "division": [3, 4], "nextDivision": [1, 0] },
    { "id": "garden-raamsteeg-2", "front": [5, 6], "division": [6, 7], "nextDivision": [1, 0] },
    { "id": "garden-raamsteeg-3", "front": [1, 2], "division": [2, 3], "nextDivision": [0, 3] },
    { "id": "garden-raamsteeg-4", "front": [0, 1] }
  ]
}
